import { render, staticRenderFns } from "./RegisterClientS2asport.vue?vue&type=template&id=af09f93a&scoped=true&"
import script from "./RegisterClientS2asport.vue?vue&type=script&lang=js&"
export * from "./RegisterClientS2asport.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClientS2asport.vue?vue&type=style&index=0&id=af09f93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af09f93a",
  null
  
)

export default component.exports